export default {
  ExportGrid: 'export-grid',
  exportGridMultipleDynamic: 'export-grid-multi', //
  ExportGridSearchVoucher: 'export-grid-search-voucher',
  ExportDynamicTemplateImport: 'export-dynamic-template-import',
  ExportXmlFinance: 'export-xml-finance',
  ExportMergeReport: 'export-merge-report', // Xuất khẩu báo cáo mẫu merge
  ExportGridMultipleSheet: 'export-grid-multiple-sheet', // xuất exel cập nhật thông tư 23
  ExportXmlSubmitTax: 'export-xml-submit-tax', // xuất xml nộp cơ quan thuế
  ExportXmlDvc: 'export-xml-dvc', // xuất xml dvc
  ExportIncurredData: 'export-incurred-data'
};
